import { SVGProps } from 'react';

const IcReturn = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='22'
      viewBox='0 0 24 22'
      fill='none'
      {...props}
    >
      <path
        d='M23.2627 20.904C23.6792 20.8699 24 20.5258 24 20.1121C24 12.4692 20.8879 8.51018 17.6507 6.50753C16.0575 5.52198 14.4693 5.03162 13.2832 4.78703C12.8028 4.68797 12.3853 4.63008 12.0565 4.59449V0.901937C12.0565 0.60421 11.8888 0.331207 11.6214 0.194897C11.3539 0.0586281 11.0317 0.0818481 10.7868 0.254938L0.336761 7.64315C0.125744 7.79234 7.49308e-05 8.03347 0 8.29014C-3.72859e-07 8.5469 0.125682 8.78791 0.336761 8.93714L10.7868 16.3264C11.0316 16.4993 11.354 16.5216 11.6214 16.3854C11.8886 16.2491 12.0563 15.9769 12.0565 15.6794V12.0614C16.507 12.2731 19.0465 14.2353 20.5017 16.1556C21.2826 17.1862 21.7621 18.2208 22.0453 18.9972C22.1864 19.3841 22.2775 19.7042 22.3329 19.9237C22.3605 20.0331 22.3791 20.1175 22.3904 20.1721C22.3961 20.1991 22.4008 20.2192 22.403 20.2312L22.4051 20.2436C22.4741 20.651 22.8467 20.9379 23.2627 20.904ZM21.787 15.2022C19.9684 12.802 16.7516 10.4506 11.2533 10.4506C10.8099 10.4508 10.4502 10.8068 10.4501 11.2456V14.1349L2.18477 8.29118L10.4501 2.44749V5.33465C10.4501 5.77363 10.8098 6.12951 11.2533 6.12969H11.2543C11.2574 6.12972 11.2636 6.13055 11.2721 6.13072C11.2892 6.13106 11.3172 6.13125 11.3547 6.13279C11.4304 6.13592 11.5461 6.14235 11.6957 6.15557C11.9956 6.18208 12.4308 6.23569 12.9559 6.34397C14.0091 6.56115 15.4069 6.99499 16.7994 7.8564C18.8347 9.11551 20.9379 11.3378 21.8811 15.3336C21.8493 15.2905 21.8197 15.2454 21.787 15.2022Z'
        fill={props.fill || '#232F3E'}
      />
    </svg>
  );
};

export default IcReturn;
